import { LegacyStreetAddressStorageManager } from "./LegacyStreetAddressStorageManager";
/**
 * Saves and restores StreetAddress from/to the previous implementation's address storage.
 */
export class LegacyStreetAddressStorageManagerAdapter {
    constructor(data) {
        this.data = data;
        this.storageManger = new LegacyStreetAddressStorageManager();
    }
    store() {
        this.storageManger.store(this.data);
    }
    /**
     * @returns true if an address was found in the storage
     */
    restore() {
        var _a, _b, _c, _d;
        const stored = this.storageManger.restore();
        if (stored === null ||
            stored.city === "" ||
            stored.street === "" ||
            stored.streetNumber === ""
        // Note: postCode not required
        ) {
            return false;
        }
        this.data.city = (_a = stored.city) !== null && _a !== void 0 ? _a : "";
        this.data.street = (_b = stored.street) !== null && _b !== void 0 ? _b : "";
        this.data.streetNumber = (_c = stored.streetNumber) !== null && _c !== void 0 ? _c : "";
        this.data.postCode = (_d = stored.postCode) !== null && _d !== void 0 ? _d : "";
        return true;
    }
}
